import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import { FunctionalComponent } from 'vue';
import { MaybeRef } from '@vueuse/core';

import {
    PuzzlePieceIcon,
    UserGroupIcon,
    Cog8ToothIcon,
    CreditCardIcon,
    ChartPieIcon,
} from '@heroicons/vue/24/outline';

interface ILink {
    name: string;
    href: string;
    icon: FunctionalComponent;
    count?: MaybeRef<number>;
    id: string;
    tooltip?: string;
    new_feature_visited?: boolean;
}

export default () => {
    const page = computed(() => usePage<ITopolPageProps>().url);
    const globalProps = computed(() => usePage<ITopolPageProps>().props);
    const isPersonalTeam = computed(
        () => usePage<ITopolPageProps>().props.team.personal_team
    );
    const { subscriptionRouteName } = useSubscriptionLabel();

    const { isPluginSubscribed } = useSubscriptions();
    const { membersCount } = useTeamsAndMembers();

    const linksPlugin = computed((): ILink[] => {
        const links: ILink[] = [
            {
                name: 'Plugin',
                href: route('plugin.api-tokens.index'),
                icon: PuzzlePieceIcon,
                count: undefined,
                id: '/plugin',
            },
            {
                name: 'Usage statistics',
                href: route('usage-statistics'),
                icon: ChartPieIcon,
                count: undefined,
                id: '/usage-statistics',
            },
        ];

        if (!isPersonalTeam.value || isPluginSubscribed.value) {
            links.splice(1, 0, {
                name: 'Members',
                href: route('members.index'),
                icon: UserGroupIcon,
                count: membersCount.value,
                id: '/members',
            });
        }

        if (
            globalProps.value.team_role.key === 'owner' ||
            globalProps.value.team_role.key === 'admin' ||
            globalProps.value.team_role.key === 'editor'
        ) {
            links.push({
                name: 'Settings',
                href: route('settings.profile-settings.index'),
                icon: Cog8ToothIcon,
                count: undefined,
                id: '/settings',
            });
        }

        if (globalProps.value.team_role.key === 'owner') {
            links.push({
                name: 'Billing',
                href: route(subscriptionRouteName.value),
                icon: CreditCardIcon,
                count: undefined,
                id: '/billing/',
            });
        }

        return links;
    });

    return {
        links: linksPlugin,
    };
};

